/**
 * Calculate the size of a string in bytes (UTF-8 encoding)
 * @param str The string to measure
 * @returns Size in bytes
 */
export function getContentSizeInBytes(str: string): number {
  // Use Blob to accurately calculate UTF-8 byte size
  return new Blob([str]).size;
}

/**
 * Maximum allowed content size in bytes (4MB)
 */
export const MAX_CONTENT_SIZE_BYTES = 4 * 1024 * 1024; // 4MB

/**
 * Check if content size exceeds the maximum allowed size
 * @param content The content to validate
 * @returns true if valid (within limit), false if exceeds limit
 */
export function isContentSizeValid(content: string): boolean {
  const sizeInBytes = getContentSizeInBytes(content);
  return sizeInBytes <= MAX_CONTENT_SIZE_BYTES;
}

/**
 * Format bytes to human-readable format
 * @param bytes Size in bytes
 * @returns Formatted string (e.g., "2.5 MB")
 */
export function formatBytes(bytes: number): string {
  if (bytes === 0) {
    return "0 Bytes";
  }

  const k = 1024;
  const sizes = ["Bytes", "KB", "MB", "GB"];
  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return `${(bytes / Math.pow(k, i)).toFixed(2)} ${sizes[i]}`;
}
